import React, { useState } from 'react'
import AddIcon from '@material-ui/icons/Add'
import { TabbedPage, Tab } from 'components/Shared/TabbedPage'
import FloatingActionButton from 'components/Shared/FloatingActionButton'
import AddWorkItem from 'components/WorkItems/AddWorkItem'
import WorkItemGrid from 'components/WorkItems/WorkItemGrid'
import ImportWorkItems from 'components/WorkItems/ImportWorkItems'
import { FormProvider } from 'context/FormContext'
import AuthCheck from 'components/Shared/AuthCheck'




const tabs = [
  new Tab({ label: "Work Items", value: "WorkItemGrid", scope: "WorkItems", action: "read" }),
  new Tab({ label: "Import Work Items", value: "impWorkItems", scope: "WorkItems", action: "create" }),
  new Tab({ label: "Add Work Items", value: "addWorkItems", scope: "WorkItems", action: "create" })
]

const WorkItems = () => {
  const [activeTab, setActiveTab] = useState("WorkItemGrid")



  return (
    <div>
      <FormProvider>
        <TabbedPage
          tabs={tabs}
          activeTab={activeTab}
          tabSetterFunc={setActiveTab}
        >
          {(() => {
            switch (activeTab) {
              case "WorkItemGrid": return <WorkItemGrid />
              case "impWorkItems": return <ImportWorkItems callback={() => { setActiveTab("WorkItemGrid") }} />
              case "addWorkItems": return <AddWorkItem CRUDType="INSERT" callback={() => { setActiveTab("WorkItemGrid") }} />
              default: return <WorkItemGrid />
            }
          })()}

          <AuthCheck scope="WorkItems" action="create"><FloatingActionButton onClick={() => setActiveTab("addWorkItems")}><AddIcon /></FloatingActionButton></AuthCheck>
        </TabbedPage>
      </FormProvider>
    </div>
  )
}

export default WorkItems